export const DELIMITER = '-'

/**
 * Slug prefixes reserved for short URLs (e.g. `/e-abc123` → `/events/abc123`).
 * Actor slugs (guilds, users) must not start with these prefixes.
 */
export const RESERVED_SLUG_PREFIXES = ['e-', 'p-'] as const

export const RESERVED_SLUG_REGEX = /^[ep]-/i

export function hasReservedSlugPrefix(slug: string): boolean {
  return RESERVED_SLUG_REGEX.test(slug)
}

/**
 * Format is ${name-delimited-with-hypens}-${slug}.
 */
export function getSlugFromPrettyUrl(prettyUrl = '') {
  const slug = prettyUrl.split(DELIMITER).pop()

  return (slug || '').toLowerCase()
}
